
// vue
import { defineComponent } from 'vue';

// atoms
import Heading from '../atoms/Heading.vue';
import RetinaImg from '../atoms/RetinaImg.vue';
// organisms
import TopHeadEnglish from './TopHeadEnglish.vue';
import TopCard from './TopCard.vue';

export default defineComponent({
  name: 'Issue',
  components: {
    Heading,
    RetinaImg,
    TopHeadEnglish,
    TopCard,
  },
  setup() {},
});
